import type { FloraInstance } from '@/flora/FloraInstance';

export interface ScreenRect {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
}

export interface ScreenPoint {
  id: string;
  x: number;
  y: number;
}

/** Ids of every instance sharing a flora definition (select-by-species, spec §4.3). */
export function idsOfSpecies(instances: Iterable<FloraInstance>, definitionId: string): string[] {
  const ids: string[] = [];
  for (const inst of instances) {
    if (inst.floraDefinitionId === definitionId) ids.push(inst.id);
  }
  return ids;
}

/** Normalize two corner points into an ordered rectangle. */
export function rectFromCorners(ax: number, ay: number, bx: number, by: number): ScreenRect {
  return {
    minX: Math.min(ax, bx),
    minY: Math.min(ay, by),
    maxX: Math.max(ax, bx),
    maxY: Math.max(ay, by),
  };
}

/** Ids whose projected screen point falls inside `rect` (drag-box selection, spec §4.3). */
export function idsInScreenRect(points: Iterable<ScreenPoint>, rect: ScreenRect): string[] {
  const ids: string[] = [];
  for (const p of points) {
    if (p.x >= rect.minX && p.x <= rect.maxX && p.y >= rect.minY && p.y <= rect.maxY) {
      ids.push(p.id);
    }
  }
  return ids;
}
